/* Oleassence — storefront theme asset. No private API key. */
(function (w, d) {
  'use strict';
  if (w.OleassenceCartTracking) return;
  var cfg = Object.assign({ dryRun: true, debounceMs: 700,
    metric: 'Panier mis à jour — Oleassence', dedupeMs: 900000 },
    w.OleassenceCartTrackingConfig || {});
  var nativeFetch = w.fetch.bind(w), timer, busy = false, dirty = false;
  var revision = 0, lastPayload = null, lastFingerprint = '', stopped = false;
  var STORE = 'oleassence-cart-snapshot-v1';
  var root = (w.Shopify && w.Shopify.routes && w.Shopify.routes.root) || '/';
  var origin = w.location.origin;

  function allowed() {
    var privacy = w.Shopify && w.Shopify.customerPrivacy;
    try {
      return !!(privacy && privacy.marketingAllowed() && privacy.analyticsProcessingAllowed());
    } catch (_) { return false; }
  }
  function amount(value) {
    if (value == null || value === '' || !Number.isFinite(Number(value))) throw new Error('Invalid cart amount');
    return Number(value) / 100;
  }
  function url(value) {
    if (!value) return '';
    try { var u = new URL(value, origin); return /^https?:$/.test(u.protocol) ? u.href : ''; }
    catch (_) { return ''; }
  }
  function build(cart) {
    if (!cart || !Array.isArray(cart.items) || !/^[A-Z]{3}$/.test(cart.currency || '')) {
      throw new Error('Incomplete Shopify cart');
    }
    var items = cart.items.map(function (item) {
      if (!Number.isSafeInteger(Number(item.variant_id)) || Number(item.variant_id) <= 0 ||
          !Number.isInteger(Number(item.quantity)) || Number(item.quantity) <= 0) {
        throw new Error('Invalid cart line');
      }
      return {
        ProductID: String(item.product_id), VariantID: String(item.variant_id),
        Name: String(item.product_title || item.title || ''),
        VariantName: item.variant_title === 'Default Title' ? '' : String(item.variant_title || ''),
        Quantity: Number(item.quantity),
        Price: amount(item.final_price == null ? item.price : item.final_price),
        LineTotal: amount(item.final_line_price == null ? item.line_price : item.final_line_price),
        ImageURL: url(item.image || (item.featured_image && item.featured_image.url)),
        URL: url(item.url),
        HasSellingPlan: !!item.selling_plan_allocation,
        HasCustomProperties: !!(item.properties && Object.keys(item.properties).length)
      };
    });
    var total = amount(cart.total_price);
    if (total < 0) throw new Error('Negative cart amount');
    return {
      SchemaVersion: 1, Source: 'shopify-theme',
      $value: total, Total: total, TotalKnown: true,
      Currency: cart.currency, ItemCount: items.reduce(function (n, item) { return n + item.Quantity; }, 0),
      IsEmpty: items.length === 0, Items: items,
      ProductIDs: items.map(function (item) { return item.ProductID; }),
      VariantIDs: items.map(function (item) { return item.VariantID; }),
      CartURL: origin + root + 'cart',
      SnapshotAt: new Date().toISOString(),
      ShippingDestinationKnown: false
    };
  }
  function fingerprint(payload) {
    return JSON.stringify([payload.Currency, payload.Total, payload.Items]);
  }
  function seen(fp) {
    if (fp === lastFingerprint) return true;
    try {
      var previous = JSON.parse(w.sessionStorage.getItem(STORE) || 'null');
      return !!(previous && previous.fp === fp && Date.now() - previous.at < cfg.dedupeMs);
    } catch (_) { return false; }
  }
  function remember(fp) {
    lastFingerprint = fp;
    try { w.sessionStorage.setItem(STORE, JSON.stringify({ fp: fp, at: Date.now() })); }
    catch (_) { /* Tracking continues if storage is unavailable. */ }
  }
  function bounded(promise) {
    return new Promise(function (resolve, reject) {
      var timeout = w.setTimeout(function () { reject(new Error('Klaviyo timeout')); }, 5000);
      Promise.resolve(promise).then(function (result) {
        w.clearTimeout(timeout); resolve(result);
      }, function (error) { w.clearTimeout(timeout); reject(error); });
    });
  }
  async function capture() {
    if (busy || stopped || !allowed()) return;
    busy = true; dirty = false;
    var version = revision;
    try {
      var response = await nativeFetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' });
      if (!response.ok) return;
      var payload = build(await response.json());
      if (version !== revision || !allowed() || stopped) return;
      lastPayload = payload;
      var fp = fingerprint(payload);
      if (cfg.dryRun || seen(fp)) return;
      if (!w.klaviyo || typeof w.klaviyo.isIdentified !== 'function' || typeof w.klaviyo.track !== 'function') return;
      var identified = await bounded(w.klaviyo.isIdentified());
      if (!identified || version !== revision || !allowed() || stopped) return;
      // A distinct ID per accepted update; retries of this request retain this ID.
      payload.$event_id = 'oa-cart-' + (w.crypto && w.crypto.randomUUID ? w.crypto.randomUUID() : Date.now() + '-' + Math.random().toString(36).slice(2));
      var accepted = await bounded(w.klaviyo.track(cfg.metric, payload));
      if (accepted === true) remember(fp);
    } catch (_) {
      // Never break add-to-cart or checkout if tracking fails.
    } finally {
      busy = false;
      if (dirty && !stopped) schedule();
    }
  }
  function schedule() {
    if (stopped) return;
    revision += 1; dirty = true;
    w.clearTimeout(timer); timer = w.setTimeout(capture, cfg.debounceMs);
  }
  function isMutation(input, method) {
    try {
      var u = new URL(typeof input === 'string' ? input : input.url, origin);
      return u.origin === origin && /\/cart\/(add|change|update|clear)(\.js)?\/?$/.test(u.pathname) &&
        String(method || (input && input.method) || 'GET').toUpperCase() !== 'GET';
    } catch (_) { return false; }
  }
  var wrappedFetch = function (input, options) {
    var watched = isMutation(input, options && options.method);
    return nativeFetch(input, options).then(function (response) {
      if (watched && response.ok) schedule();
      return response;
    });
  };
  w.fetch = wrappedFetch;
  var proto = w.XMLHttpRequest && w.XMLHttpRequest.prototype;
  var nativeOpen = proto && proto.open, nativeSend = proto && proto.send;
  var flags = new WeakMap();
  function wrappedOpen(method, requestURL) {
    flags.set(this, isMutation(requestURL, method));
    return nativeOpen.apply(this, arguments);
  }
  function wrappedSend() {
    if (flags.get(this)) this.addEventListener('load', function () {
      if (this.status >= 200 && this.status < 300) schedule();
    }, { once: true });
    return nativeSend.apply(this, arguments);
  }
  if (proto) { proto.open = wrappedOpen; proto.send = wrappedSend; }
  function consentChanged() {
    if (!allowed()) {
      lastPayload = null; lastFingerprint = '';
      try { w.sessionStorage.removeItem(STORE); } catch (_) { /* No storage. */ }
    }
    schedule();
  }
  function visible() { if (d.visibilityState === 'visible') schedule(); }
  function formEvent(event) {
    if (event.detail && event.detail.type === 'submit') {
      schedule(); w.setTimeout(schedule, 2000);
    }
  }
  d.addEventListener('visitorConsentCollected', consentChanged);
  d.addEventListener('visibilitychange', visible);
  w.addEventListener('pageshow', schedule);
  w.addEventListener('klaviyoForms', formEvent);
  d.addEventListener('oleassence:cart-updated', schedule);
  if (w.Shopify && typeof w.Shopify.loadFeatures === 'function' && !w.Shopify.customerPrivacy) {
    w.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (error) {
      if (!error) schedule();
    });
  }
  // Retry initial consent / SDK loading; no polling for the rest of the visit.
  var startupTimers = [0, 1500, 5000, 15000].map(function (delay) { return w.setTimeout(schedule, delay); });
  w.OleassenceCartTracking = {
    version: '1.0.0', dryRun: cfg.dryRun,
    refresh: schedule,
    preview: function () { return lastPayload ? JSON.parse(JSON.stringify(lastPayload)) : null; },
    stop: function () {
      stopped = true; w.clearTimeout(timer); startupTimers.forEach(w.clearTimeout.bind(w));
      if (w.fetch === wrappedFetch) w.fetch = nativeFetch;
      if (proto && proto.open === wrappedOpen) proto.open = nativeOpen;
      if (proto && proto.send === wrappedSend) proto.send = nativeSend;
      d.removeEventListener('visitorConsentCollected', consentChanged);
      d.removeEventListener('visibilitychange', visible);
      w.removeEventListener('pageshow', schedule);
      w.removeEventListener('klaviyoForms', formEvent);
      d.removeEventListener('oleassence:cart-updated', schedule);
      lastPayload = null;
    }
  };
})(window, document);
